export const deleteWhitespaces = (text: string) => text.replace(/\s+/g, '');
